import { Container, Stack, Typography } from '@mui/material';

const Footer = () => {
  const fullYear = new Date().getFullYear();

  return (
    <Stack direction="row" className="justify-center w-full z-50">
      <Container disableGutters maxWidth="lg">
        <Stack direction="row" className="items-center h-14 px-4 md:px-6 lg:mx-8 border-t sm:shadow-xl bg-paper">
          <Typography variant="body2" component="div" className="text-secondary">
            eLogic Biometrics &copy; {fullYear}
          </Typography>
        </Stack>
      </Container>
    </Stack>
  );
};

export default Footer;
